module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "dofCell",
    staticClass: " weex-ct weex-div",
    class: [
      'dof-cell',
      _vm.clickActivied && 'active-cell',
      _vm.hasTopBorder && 'cell-top-border',
      _vm.hasBottomBorder && 'cell-bottom-border',
      _vm.hasMargin && 'cell-margin',
      _vm.hasBottomBorder && _vm.isIos ? 'ios-bottom-border' : ''
    ],
    style: (_vm._px2rem(_vm.outputCellStyle, 75)),
    attrs: {
      "weex-type": "div",
      "data-evt-click": "",
      "data-evt-touchstart": "",
      "data-evt-touchmove": "",
      "data-evt-touchend": "",
      "data-evt-touchcancel": ""
    },
    on: {
      "click": _vm.$stopOuterA,
      "touchstart": function($event) {
        $event.stopPropagation();
        return _vm.startDrag($event)
      },
      "touchmove": function($event) {
        $event.stopPropagation();
        return _vm.onDrag($event)
      },
      "touchend": function($event) {
        $event.stopPropagation();
        return _vm.endDrag($event)
      },
      "touchcancel": function($event) {
        $event.stopPropagation();
        return _vm.endDrag($event)
      },
      "weex$tap": function($event) {
        $event.stopPropagation();
        return _vm.cellClicked($event)
      }
    }
  }, [_vm._t("itemImg", [(_vm.itemImg && _vm.itemImg != '') ? _c('figure', {
    staticClass: "item-image weex-el weex-image",
    style: (_vm._px2rem(_vm.imgStyle, 75)),
    attrs: {
      "src": _vm.itemImg,
      "data-img-src": _vm.itemImg,
      "weex-type": "image"
    }
  }) : _vm._e()], {}), _vm._v(" "), _c('div', {
    staticClass: " weex-ct weex-div",
    class: [
      'dof-sub-cell',
      _vm.hasSubTopBorder && 'cell-sub-top-border',
      _vm.hasSubBottomBorder && 'cell-sub-bottom-border',
      _vm.hasSubBottomBorder && _vm.isIos ? 'ios-sub-bottom-border' : ''
    ],
    style: (_vm._px2rem(_vm.subCellStyle, 75)),
    attrs: {
      "weex-type": "div"
    }
  }, [_c('div', {
    staticClass: " weex-ct weex-div",
    class: ['dof-sub-cell-inner'],
    attrs: {
      "weex-type": "div"
    }
  }, [_c('div', {
    staticClass: "content weex-ct weex-div",
    attrs: {
      "weex-type": "div"
    }
  }, [_c('div', {
    staticClass: "cell-title weex-ct weex-div",
    attrs: {
      "weex-type": "div"
    }
  }, [_c('p', {
    staticClass: " weex-el weex-text",
    class: [_vm.title && _vm.hasArrow ? 'cell-content' : 'cell-content-no-arrow', _vm.tag ? 'hasTag' : 'noTag'],
    attrs: {
      "weex-type": "text"
    }
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), (_vm.tag && _vm.tag != '') ? _c('p', {
    staticClass: "cell-title-btn weex-el weex-text",
    attrs: {
      "weex-type": "text"
    }
  }, [_vm._v(_vm._s(_vm.tag))]) : _vm._e()]), _vm._v(" "), (_vm.desc) ? _c('p', {
    staticClass: "cell-desc-text weex-el weex-text",
    style: ({
      color: _vm.descColor,
      webkitLineClamp: _vm.size == 'max' ? 2 : 1,
      overflow: 'hidden',
      textOverflow: 'ellipsis'
    }),
    attrs: {
      "weex-type": "text"
    }
  }, [_vm._v(_vm._s(_vm.desc))]) : _vm._e()]), _vm._v(" "), _vm._t("rightText", [(_vm.rightTip) ? _c('p', {
    staticClass: "rightTip weex-el weex-text",
    attrs: {
      "weex-type": "text"
    }
  }, [_vm._v(_vm._s(_vm.rightTip))]) : _vm._e(), _vm._v(" "), (_vm.rightText) ? _c('p', {
    staticClass: "right-text weex-el weex-text",
    attrs: {
      "weex-type": "text"
    }
  }, [_vm._v(_vm._s(_vm.rightText))]) : (_vm.placeHolder) ? _c('p', {
    staticClass: "placeholder-text weex-el weex-text",
    attrs: {
      "weex-type": "text"
    }
  }, [_vm._v(_vm._s(_vm.placeHolder))]) : _vm._e()], {}), _vm._v(" "), _vm._t("switch", null, {})], 2), _vm._v(" "), (_vm.hasArrow) ? _c('dof-image', {
    staticClass: "cell-arrow-icon",
    attrs: {
      "src": _vm.arrowIcon
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.rightWidth) ? _c('div', {
    staticClass: "midea-swipe-cell__right weex-ct weex-div",
    style: (_vm._px2rem(_vm.rightStyle, 75)),
    attrs: {
      "weex-type": "div",
      "data-evt-click": ""
    },
    on: {
      "click": _vm.$stopOuterA,
      "weex$tap": function($event) {
        $event.stopPropagation();
        return _vm.rightClick($event)
      }
    }
  }, [_vm._t("right", null, {})], 2) : _vm._e()], 2)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-117e2acb", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-117e2acb","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./packages/dof-cell2/index.vue
// module id = 566
// module chunks = 0 1